/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export class MappingError extends Error {
}
//# sourceMappingURL=types.js.map